export const createposition=`mutation CreatePosition($input: CreatePositionInput!) {
  createPosition(input: $input) {
    position {
      id
      positionName
      client {
        id
        clientName
      }
    }
    success
    error
    message
  }
}
`

export const updateposition=`mutation UpdatePosition($input: UpdatePositionInput!) {
  updatePosition(input: $input) {
    position {
      id
      positionName
      client {
        id
        clientName
      }
    }
    success
    error
    message
  }
}
`

export const deleteposition=`mutation DeletePosition($input: DeletePositionInput!) {
  deletePosition(input: $input) {
    success
    error
    message
  }
}`

export const getallpostion=`
query GetAllPositions_NoPrefetch($search: String, $page: Int!, $pageSize: Int!) {
  getAllPositions(search: $search, page: $page, pageSize: $pageSize) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    data {
      id
      positionName
      createdBy
      createdAt
      lastUpdate
      updatedBy
      client {
        id
        clientName
      }
    }
  }
}
`


export const GETCLIENTDROPDOWN = `
  query GetAllClients($search: String, $page: Int!, $pageSize: Int!) {
    getAllClients(search: $search, page: $page, pageSize: $pageSize) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        clientName
        industry {
          id
          industryType
        }
        hiringType
        primaryContactPerson
        address
        mapLocation
        mailAddress
        countryCode
        contactNumber
        srDays
        createdAt
        createdBy
        lastUpdate
        updatedBy
      }
    }
  }
`;



export const getallpostionDropDown=`
query GetAllPositions_NoPrefetch($search: String, $page: Int!, $pageSize: Int!) {
  getAllPositions(search: $search, page: $page, pageSize: $pageSize) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    data {
      id
      positionName
      createdBy
      createdAt
      lastUpdate
      updatedBy
      client {
        id
        clientName
      }
    }
  }
}
`


export const getallposittionbasedonClient = `query GetPositionsByClient($clientId: Int!) {
  getPositionsByClient(clientId: $clientId) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    data {
      id
      positionName
      client {
        id
        clientName
      }
    }
  }
}`